import { render, staticRenderFns } from "./TokenDetails.vue?vue&type=template&id=74c25687&scoped=true"
import script from "./TokenDetails.vue?vue&type=script&lang=js"
export * from "./TokenDetails.vue?vue&type=script&lang=js"
import style0 from "./TokenDetails.vue?vue&type=style&index=0&id=74c25687&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c25687",
  null
  
)

export default component.exports